export default __webpack_public_path__ + "static/media/Slide4.13e02b39.png";